"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RentalTypeKeys = void 0;
var RentalTypeKeys = exports.RentalTypeKeys = ['RESIDENTIAL', 'HOLIDAY_RENTALS', 'BUILD_TO_RENT'];
var RentalTypeValues = {
  RESIDENTIAL: {
    name: 'RESIDENTIAL',
    label: 'Residential rental',
    digitalDataKey: 'Residential',
    urlSlug: 'residential'
  },
  HOLIDAY_RENTALS: {
    name: 'HOLIDAY_RENTALS',
    label: 'Holiday rental',
    digitalDataKey: 'Holiday',
    urlSlug: 'holiday-rental'
  },
  BUILD_TO_RENT: {
    name: 'BUILD_TO_RENT',
    label: 'Build-to-Rent',
    digitalDataKey: 'Build-to-Rent',
    urlSlug: 'build-to-rent'
  }
};
var RentalType = RentalTypeValues;
var _default = exports.default = RentalType;